// extracted by mini-css-extract-plugin
export default {"marker":"components-Maps-__styles__-Marker-module__marker"};